import React, { useEffect, useId, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSwitcher.css';
import langSwitcherIcon from '../../assets/common/lang_switcher.png';

export default function LanguageSwitcher({ variant = 'default' }) {
  const { language, switchLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dialogTitleId = useId();

  const isWelcome = variant === 'welcome';
  const rootClassName = [
    'language-switcher',
    isWelcome ? 'language-switcher--welcome' : '',
    language === 'he' ? 'is-he' : 'is-en',
  ]
    .filter(Boolean)
    .join(' ');

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);

  const chooseLanguage = (lang) => {
    switchLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className={rootClassName}>
      <button
        type="button"
        className="language-switcher-trigger"
        onClick={() => setIsOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={isOpen ? 'true' : 'false'}
        aria-label={language === 'he' ? 'שינוי שפה' : 'Change language'}
        title={language === 'he' ? 'שינוי שפה' : 'Change language'}
      >
        <img className="language-switcher-trigger-icon" src={langSwitcherIcon} alt="" aria-hidden="true" />
      </button>

      {isOpen && (
        <div
          className="language-switcher-modal-overlay"
          onPointerDown={(e) => {
            // Press outside closes; press inside doesn't.
            if (e.target === e.currentTarget) setIsOpen(false);
          }}
        >
          <div
            className="language-switcher-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby={dialogTitleId}
          >
            <div className="language-switcher-modal-header">
              <div className="language-switcher-modal-title" id={dialogTitleId}>
                {language === 'he' ? 'בחר שפה' : 'Choose language'}
              </div>
              <button
                type="button"
                className="language-switcher-modal-close"
                onClick={() => setIsOpen(false)}
                aria-label={language === 'he' ? 'סגירה' : 'Close'}
                title={language === 'he' ? 'סגירה' : 'Close'}
              >
                ×
              </button>
            </div>

            <div className="language-switcher-modal-body">
              <button
                type="button"
                className={`language-switcher-option ${language === 'en' ? 'active' : ''}`}
                onClick={() => chooseLanguage('en')}
              >
                <span className="language-switcher-option-label">English</span>
                {language === 'en' && <span className="language-switcher-option-check" aria-hidden="true">✓</span>}
              </button>

              <button
                type="button"
                className={`language-switcher-option ${language === 'he' ? 'active' : ''}`}
                onClick={() => chooseLanguage('he')}
              >
                <span className="language-switcher-option-label">עברית</span>
                {language === 'he' && <span className="language-switcher-option-check" aria-hidden="true">✓</span>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
